import { z } from 'zod'

export const surveyFormSchema = z.object({
  clientTitle: z.string().optional(),
  serviceType: z.string().optional(),
  rating: z.number().min(1).max(5),
  content: z.string().min(20, 'Please write at least 20 characters.'),
  consent: z.literal(true, { error: 'You must agree to display this review publicly.' }),
})

export type SurveyFormValues = z.infer<typeof surveyFormSchema>
